import { useCurrentAccount } from '@blattnercompany/react-auth'

import type { CurrentUser } from '@/components/UserChip'

/**
 * The signed-in user for display. `useCurrentAccount` picks the account the
 * same way the token interceptors do, so the chip never names a different
 * account than the one requests are sent as. Only the display mapping lives
 * here -- names, initials and fallback labels are the app's business, not the
 * auth kit's.
 */
export function useCurrentUser(): CurrentUser {
  const account = useCurrentAccount()
  const name = account?.name?.trim() || account?.username || ''
  const words = account?.name?.trim().split(/\s+/).filter(Boolean) ?? []
  const initials =
    words.length > 1
      ? `${words[0]?.[0] ?? ''}${words[words.length - 1]?.[0] ?? ''}`
      : (words[0]?.[0] ?? account?.username?.[0] ?? '')
  return { name, initials: initials.toUpperCase(), email: account?.username }
}
